/* PGPolicies.js
   Step 14 — Postgraduate (PG) Application Policies & Declarations.
   Replaces Policies.js for the PG flow only.
   Contains exactly the 9 policy clauses from SOW v3 Section 3.2 Step 15.
   Zero modifications to existing Policies.js.
*/
import React, { Component } from 'react'
import PropTypes from 'prop-types'

const PG_POLICIES = [
  {
    number: 1,
    title: 'Accuracy of Information',
    text:
      'I confirm that all information provided in this application is true, complete, and accurate to the best of my knowledge.'
  },
  {
    number: 2,
    title: 'Supporting Documents',
    text:
      'I acknowledge that all submitted documents are authentic and that providing false or misleading documents may result in rejection or withdrawal of an offer.'
  },
  {
    number: 3,
    title: 'Entry Requirements Assessment',
    text:
      'I acknowledge that meeting the minimum entry requirements does not guarantee admission, as all applications are assessed through a comprehensive review process.'
  },
  {
    number: 4,
    title: 'Interview Requirement',
    text:
      'I understand that shortlisted applicants may be required to attend an interview as part of the assessment process.'
  },
  {
    number: 5,
    title: 'Application Fee',
    text:
      'I understand that application fees, where applicable, are non-refundable once the application is submitted.'
  },
  {
    number: 6,
    title: 'Tuition Fees',
    text:
      'For Egyptian students, please note that the announced fees are stated in GBP. Tuition fee payments are collected in Egyptian Pounds (EGP) based on the exchange rate announced by the Central Bank of Egypt at the time of payment.'
  },
  {
    number: 7,
    title: 'Admission Decision',
    text:
      'I acknowledge that all admission decisions are final and made by the Admissions Committee in accordance with university regulations.'
  },
  {
    number: 8,
    title: 'Communication',
    text:
      'I confirm that the email address and phone number provided will be used for all university communications.'
  },
  {
    number: 9,
    title: 'University Regulations',
    text:
      'I confirm that, if admitted, I agree to comply with the university\'s academic rules, regulations, and policies.'
  }
]

export default class PGPolicies extends Component {
  constructor (props) {
    super(props)
    this.state = {
      acceptedPolicies: this.props.acceptedPolicies || false
    }
  }

  render () {
    const { acceptedPolicies } = this.state

    return (
      <div>
        {/* Policy clauses */}
        <div style={{ marginBottom: 20 }}>
          {PG_POLICIES.map(policy => (
            <div
              key={policy.number}
              style={{
                marginBottom: 14,
                paddingLeft: 10,
                borderLeft: '3px solid #6AA8FF'
              }}
            >
              <p style={{ fontWeight: 'bold', margin: '0 0 4px', color: '#3168CE' }}>
                {policy.number}. {policy.title}
              </p>
              <p style={{ margin: 0, fontSize: 14, color: '#444', lineHeight: 1.55 }}>
                {policy.text}
              </p>
            </div>
          ))}
        </div>

        {/* Acceptance of Policies */}
        <div
          style={{
            background: '#f0f5ff',
            border: '1px solid #b3c9f0',
            borderRadius: 8,
            padding: '14px 18px',
            marginTop: 20
          }}
        >
          <h5 style={{ margin: '0 0 10px', color: '#2c3e50' }}>Acceptance of Policies</h5>
          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
            <input
              type='checkbox'
              checked={acceptedPolicies}
              style={{ minWidth: 'auto', marginTop: 2 }}
              onChange={() => {
                const newVal = !this.state.acceptedPolicies
                this.setState({ acceptedPolicies: newVal })
                this.props.collectState('Policies', newVal)
              }}
            />
            <span style={{ fontSize: 14, color: '#333' }}>
              I confirm that I have read, understood, and agree to the Application Policy.
            </span>
          </label>
        </div>
      </div>
    )
  }
}

PGPolicies.propTypes = {
  collectState: PropTypes.func.isRequired,
  acceptedPolicies: PropTypes.bool
}

PGPolicies.defaultProps = {
  acceptedPolicies: false
}
